import React from "react";
import styles from "./ActionHeader.module.scss";
import { Button, ButtonProps } from "antd";

interface ActionHeaderProps extends React.HTMLProps<HTMLDivElement> {
  rowCount?: number;
  actions?: Action[];
  disabled?: boolean;
}

interface Action extends ButtonProps {
  icon?: React.ReactNode | string;
  label?: string;
  userClick?: () => void;
  title?: string;
  isNormal?: boolean;
  onRight?: boolean; // position of button
}

function ActionHeader(props: ActionHeaderProps) {
  const { rowCount, actions, ref, disabled, ...rest } = props;

  const renderItem = (action: Action, indexItem: number) => {
    const { userClick, isNormal, ...restProps } = action;
    if (isNormal || typeof action.icon == "string") {
      return (
        <Button
          key={indexItem}
          className={`${action?.label ? "flex justify-content-center align-items-center" : "p-0"}`}
          disabled={action?.disabled || false}
          icon={action?.icon}
          onClick={() => userClick?.()}
          style={{
            width: action?.label ? "fit-content" : 32, // if has label => width need more large
            minWidth: action?.label ? "90px" : 32,
            height: 32,
          }}
          variant="solid"
          color="primary"
          {...restProps}
        >
          {action?.label}
        </Button>
      );
    }

    return (
      <div key={indexItem} onClick={() => userClick?.()}>
        {action.icon}
      </div>
    );
  };

  return (
    <div ref={ref} {...rest} className={"flex flex-row p-1 actions w-100"}>
      <div
        className={"flex flex-row gap-2 align-items-center"}
        style={{
          flexGrow: 1,
        }}
      >
        {actions?.filter((a) => !a.onRight)?.map((action, index) => renderItem(action, index))}
      </div>
      <div
        className={" flex flex-row gap-2 align-items-center justify-content-end"}
        style={{
          flexGrow: 1,
        }}
      >
        {actions?.filter((a) => a.onRight)?.map((action, index) => renderItem(action, index))}
        {rowCount !== undefined ? (
          <div
            className={`${styles.countText} pl-2 pr-2`}
          >{`Tổng số bản ghi: ${rowCount}`}</div>
        ) : null}
      </div>
    </div>
  );
}

export default ActionHeader;
